import { IPlaceholdersConfig } from "../../IPlaceholdersConfig";

export const DEFAULT_PLACEHOLDERS: IPlaceholdersConfig = {
  pan: "**** **** **** ****",
  expirydate: "MM/YY",
  securitycode: "***",
};
